import { ACTIONS } from "../../context/ExcelFileUploadProvider";
import { InputWithFileUpload } from "./Shared";

export const InputFile = ({
  excelWorkBook,
  setExcelWorkSheetName,
  setExceedLimitError,
  readFile,
  dispatch,
  suffix,
}) => {
  return (
    <InputWithFileUpload
      type="file"
      label={
        excelWorkBook?.Props?.Title
          ? excelWorkBook.Props.Title
          : Object.values(excelWorkBook).length > 0
          ? "File selected"
          : "Select file"
      }
      id="excel-file"
      onChange={(e) => {
        setExcelWorkSheetName("");
        setExceedLimitError(false);
        readFile(e.target.files[0], dispatch);
        dispatch({ type: ACTIONS.SET_EXCEL_FILE, payload: { value: e.target.files[0] } });
      }}
      suffix={suffix}
      hidden
    />
  );
};
